<template>
    <section class="rate-us">
        <div class="review-product container">
            <div v-if="isRestaurantLogoVisible"
                 class="dz-media">
                <img :src="this.$store.state.companyData.locale.logo"
                     id="company-logo"
                     alt="">
            </div>
            <h6 class="title">{{ this.$store.state.companyData.locale.name }}</h6>
            <div v-if="this.$store.state.companyData.locale.wifi_ussd">
                <i class="fa fa-wifi"
                   aria-hidden="true"></i> WiFi:
                {{ this.$store.state.companyData.locale.wifi_ussd }}
                <br>
                {{ $t("Password") }}: {{ this.$store.state.companyData.locale.wifi_password }}
            </div>
        </div>
        <div v-if="!reviewSent"
             class="write-reviews-box container">
            <div class="reviews-head">
                <h5 class="title">{{ $t('pages.review.title') }}</h5>
                <p>{{ $t('pages.review.message') }}</p>
            </div>
            <div class="rating-info">
                <ul class="rating-list">
                    <li><i class="fa-star"
                           v-bind:class="{ fas: activeRating >= 1, far: activeRating == 0 }"
                           @click="setRating(1)"></i></li>
                    <li><i class="fa-star"
                           v-bind:class="{ fas: activeRating >= 2, far: activeRating < 2 }"
                           @click="setRating(2)"></i></li>
                    <li><i class="fa-star"
                           v-bind:class="{ fas: activeRating >= 3, far: activeRating < 3 }"
                           @click="setRating(3)"></i></li>
                    <li><i class="fa-star"
                           v-bind:class="{ fas: activeRating >= 4, far: activeRating < 4 }"
                           @click="setRating(4)"></i></li>
                    <li><i class="fa-star"
                           v-bind:class="{ fas: activeRating >= 5, far: activeRating < 5 }"
                           @click="setRating(5)"></i></li>
                </ul>
            </div>
            <form class="form-elements">
                <div class="list">
                    <ul class="row">
                        <li class="item-content item-input col-100">
                            <div class="item-inner">
                                <div class="item-input-wrap">
                                    <textarea v-model="message"
                                              :placeholder="$t('Write your review here')"
                                              class="form-control"></textarea>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </form>
            <VButton v-on:click.native="sendReview()"
                     type="violet">
                {{
                    $t('SUBMIT REVIEW')
                }}
            </VButton>
        </div>
        <div v-else-if="reviewSent && activeRating >= 4"
             class="write-reviews-box container">
            <div class="reviews-head">
                <h5 class="title">{{ $t("pages.review.also") }}:</h5>

                <a v-if="url.tripadvisor"
                   :href="url.tripadvisor"
                   target="_blank">
                    <img src="/img/socials/tripadvisor.jpg"
                         class="social-image"
                         alt="">
                </a>

                <a v-if="url.google_url"
                   :href="url.google_url"
                   target="_blank">
                    <img src="/img/socials/google.jpg"
                         class="social-image"
                         alt="">
                </a>

                <a v-if="url.facebook_url"
                   :href="url.facebook_url"
                   target="_blank">
                    <img src="/img/socials/facebook.png"
                         class="social-image"
                         alt="">
                </a>

                <a v-if="url.yelp_url"
                   :href="url.yelp_url"
                   target="_blank">
                    <img src="/img/socials/yelp.jpg"
                         class="social-image"
                         alt="">
                </a>

                <a v-if="url.zomato_url"
                   :href="url.zomato_url"
                   target="_blank">
                    <img src="/img/socials/zomato.jpg"
                         class="social-image"
                         alt="">
                </a>
            </div>
        </div>
        <div v-else
             class="temp_pluck">
            <div class="temp_pluck__title"
                 :style="{ background: computedCompanyData.colors.main }">
                <img :src="computedCompanyData.locale.logo"
                     alt="Company Logo">
            </div>
            <div class="reviews-head">
                <h5 class="title">{{ $t('pages.reviewLow.title') }}</h5>
                <p>{{ $t('pages.reviewLow.message') }}</p>
            </div>
        </div>
    </section>
</template>

<script>
import VButton from "@/components/ui/VButton.vue";
import { BASE_API_URL } from "@/appConstants";
import axios from "axios";
import router from "@/router/router";

export default {
    name: "VReviewAdd",
    components: {
        VButton
    },
    props: {
        isRestaurantLogoVisible: { type: Boolean, default: true }
    },
    data() {
        return {
            activeRating: 0,
            message: "",
            reviewSent: false,
            url: {
                tripadvisor: null,
                google_url: null,
                facebook_url: null,
                yelp_url: null,
                zomato_url: null,
            }
        };
    },
    mounted() {
        for (const key in this.url) {
            if (Object.prototype.hasOwnProperty.call(this.computedCompanyData.locale, key)) {
                this.url[key] = this.toHttpsUrl(this.computedCompanyData.locale[key]);
            }
        }
    },
    computed: {
        computedCompanyData: function () {
            return this.$store.getters['getCompanyData'];
        },
        comTable () {
            return this.$store.getters['getTableData'];
        }
    },
    methods: {
        setRating(val) {
            this.activeRating = val;
        },
        sendReview() {
            if (this.activeRating === 0) {
                this.$toast("Wybierz ocene", {
                    timeout: 2000
                });
                return;
            }

            var endpoint = BASE_API_URL +
                'addreview?locale_id=' + this.$store.state.companyData.locale.id +
                '&mark=' + this.activeRating +
                '&review=' + this.message;

            if(this.comTable) {
              endpoint += '&table_id=' + this.comTable.id;
            }

            axios.get(endpoint).then(
                response => {
                    if (response.status === 200) {
                        this.$toast.success('Dziękujemy!');
                        this.reviewSent = true;
                    }
                }
            ).catch(error => {
                router.push('error');
                console.log(error);
            });
        },
        toHttpsUrl(input) {
            if (!/^https?:\/\//i.test(input)) {
                input = 'https://' + input;
            }

            try {
                const url = new URL(input);

                if (!/\.[a-z]{2,}$/i.test(url.hostname)) {
                    throw new Error('Invalid domain');
                }

                url.protocol = 'https:';
                return url.toString();
            } catch (err) {
                console.error('Invalid URL:', input, '|', err.message);
                return null;
            }
        }
    },
};
</script>

<style scoped>
.temp_pluck {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.temp_pluck__title {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    border-radius: 16px;
}

.temp_pluck__title img {
    max-height: 96px;
    max-width: 50%;
}

.temp_pluck .reviews-head {
    padding: 12px;
    border: 2px solid #656565;
    border-radius: 12px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #656565;
}

.review-product {
    padding: 0 0 20px 0;
}

.write-reviews-box {
    padding-left: 0;
    padding-right: 0;
}

#company-logo {
    max-width: 180px;
    background-color: white;
    border-radius: 20px;
    padding: 20px;
}

.review-product .dz-media {
    width: auto;
    height: auto;
}

.social-image {
    max-width: 100%;
    border-radius: 15px;
    margin-bottom: 20px;
}
</style>
